import React from 'react';
import "./ImgContextMenuIcons.scss"

const FitWidthSVG = () => {
	return (
		<svg className="horiz-context-menu-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path fill="#1A2038" d="M140-140v-680h64.62v680H140Zm615.38 0v-680H820v680h-64.62ZM293.85-447.69v-64.62h64.61v64.62h-64.61Zm153.84 0v-64.62h64.62v64.62h-64.62Zm153.85 0v-64.62h64.61v64.62h-64.61Z" /></svg>
	);
}

export default FitWidthSVG;